import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
  data: null,
  isLoading: false,
  error: null
};

const lookupSlice = createSlice({
  name: 'lookup',
  initialState,
  reducers: {
    setLookups: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setLoading: (state) => {
      state.isLoading = true;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    }
  }
});

export const { setLookups, setLoading, setError } = lookupSlice.actions;

export const fetchLookups = () => async (dispatch) => {
  dispatch(setLoading());
  try {
    const accessToken = localStorage.getItem('NCProAccessToken');
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_BASE_URL}/master-data`, {
      headers: { Authorization: `Bearer ${accessToken}` }
    });
    const lookupData = response.data.lookupTypesAndValues.reduce((acc, item) => {
      acc[item.lookup_type] = item.lookup_value ? item.lookup_value.split(", ").map(value => value.trim()) : [];
      return acc;
    }, {});

    dispatch(setLookups(lookupData));
  } catch (error) {
    dispatch(setError(error.message));
  }
};

export default lookupSlice.reducer;
